// import Home from "./components/Home";
// import About from "./components/About";
// import Contact from "./components/Contact";
// import Secret from "./components/Secret";

import HomePage from './container/home_page';
import ProductPage from './container/product_page';
import ShoppingCart from './container/shopping_cart_page';
import PaymentPage from './container/payment_page';
import PaymentComplete from './container/payment_complete_page';
import Download from './container/download';
import AboutLUBANSO from './container/about_lubanso';
import Team from './container/team';
import Alliance from './container/alliance';
import AllianceUser from './container/alliance_user';
import Announcement from './container/announcement';
import AnnouncementDetail from './container/announcement_detail';

export default [
  {
    path: "/product/payment/payment_complete",
    component: PaymentComplete,
    exact: true,
  },
  {
    path: "/product/payment",
    component: PaymentPage,
    exact: true,
  },
  {
    path: "/product/productCart",
    component: ShoppingCart,
    exact: true,
  },
  {
    path: "/X1",
    component: ProductPage,
    exact: true,
  },
  {
    path: "/download",
    component: Download,
    exact: true,
  },
  {
    path: "/about",
    component: AboutLUBANSO,
    exact: true,
  },
  {
    path: "/team",
    component: Team,
    exact: true,
  },
  {
    path: '/affiliates/:id',
    component: AllianceUser,
    exact: true,
  },
  {
    path: '/affiliates',
    component: Alliance,
    exact: true,
  },
  {
    path: '/announcement_detail',
    component: AnnouncementDetail,
    exact: true,
  },
  {
    path: '/announcement',
    component: Announcement,
    exact: true
  },
  {
    path: "/",
    component: HomePage,
  }
];
